import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'
import OrderStatusColor from '@/mixins/orders/orderStatus'
import OrderSourceType from '@/mixins/orders/sourceType'
import OrderPaymentType from '@/mixins/orders/paymentType'
import OrderType from '@/mixins/orders/orderType'
import OrderTypeTime from '@/mixins/orders/orderTypeTime'
import OrderStatusEnum from '@/api/Enums/OrderStatusEnum'
import FiscalDocTypeEnum from '@/api/Enums/FiscalDocTypeEnum'

export default {
  data() {
    return {}
  },
  components: {},
  mixins    : [Auth, AppData, OrderStatusColor, OrderSourceType, OrderPaymentType, OrderType, OrderTypeTime, OrderStatusEnum],
  props     : {},
  directives: {},
  watch     : {},
  methods   : {
    orderFiscalDocuments(order, includeDocsWithError = false) {
      const retVal = order?.Receipts || []

      if (!includeDocsWithError) return retVal.filter(item => !this.orderFiscalDocumentHasError(item))

      return retVal
    },
    orderLatestFiscalDocument(order, includeDocsWithError = false) {
      return this.orderHasFiscalDocument(order, includeDocsWithError) ? {...(this.orderFiscalDocuments(order)[0] || {}), OrderId: order?.Id || null} : null
    },
    orderLatestFiscalDocumentHasError(order) {
      return this.orderFiscalDocuments(order, true)?.length > 1 ? this.orderFiscalDocumentHasError(this.orderLatestFiscalDocument(order, true)) : this.orderHasFiscalDocumentWithError(order)
    },
    orderFiscalDocumentBadgeColor(order) {
      const hasError = this.orderLatestFiscalDocumentHasError(order)
      return hasError ? 'red' : this.orderHasReceipt(order, hasError) && this.orderHasInvoice(order, hasError) ? 'teal' : this.orderHasReceipt(order, hasError) ? 'green' : this.orderHasInvoice(order, hasError) ? 'blue' : this.orderIsGeneratingFiscalDocument(order) ? 'deep-purple lighten-3' : 'red'
    },
    orderHasFiscalDocument(order, includeDocsWithError = false) {
      return !!this.orderFiscalDocuments(order, includeDocsWithError).length
    },
    orderReceiptsCount(order, includeDocsWithError = false) {
      return this.orderFiscalDocuments(order, includeDocsWithError).filter(doc => FiscalDocTypeEnum.isReceipt(doc.ReceiptType)).length
    },
    orderHasReceipt(order, includeDocsWithError = false) {
      return this.orderReceiptsCount(order, includeDocsWithError) > 0
    },
    orderInvoicesCount(order, includeDocsWithError = false) {
      return this.orderFiscalDocuments(order, includeDocsWithError).filter(doc => FiscalDocTypeEnum.isInvoice(doc.ReceiptType)).length
    },
    orderFiscalDocumentCount(order, includeDocsWithError = false) {
      return (this.orderInvoicesCount(order, includeDocsWithError) + this.orderReceiptsCount(order, includeDocsWithError))
    },
    orderHasInvoice(order, includeDocsWithError = false) {
      return this.orderInvoicesCount(order, includeDocsWithError) > 0
    },
    orderCanGenerateFiscalDocument(order) {
      return !!order?.CanGenerateReceipt && !!order?.PaymentTransactions?.length && !this.orderIsGeneratingFiscalDocument(order)
    },
    orderIsGeneratingFiscalDocument(order) {
      return !!order?.IsGeneratingReceipt && !this.orderHasReceipt(order)
    },
    orderHasFiscalDocumentWithError(order) {
      return this.orderFiscalDocuments(order, true).some(item => this.orderFiscalDocumentHasError(item))
    },
    orderFiscalDocumentHasError(doc) {
      return !!doc?.ErrorCode
    },
    orderFiscalDocumentErrorCode(doc) {
      return doc?.ErrorCode || ''
    },
    orderFiscalDocumentErrors(doc) {
      return doc?.Errors || []
    }

  },
  computed: {},
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }

}
